// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"328":"b7109927","840":"a41485ff","962":"d633c6b3"}[chunkId] + ".css";
};